var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5006 0C25.7569 0 24.0527 0.161638 22.4001 0.472878C19.8963 0.942317 17.5129 1.75051 15.2997 2.84758C6.23201 7.34422 0 16.6952 0 27.5009C0 42.688 12.311 55 27.5006 55C42.6886 55 55.0012 42.688 55.0012 27.5009C55.0012 12.312 42.6886 0 27.5006 0ZM27.4765 7.96498C32.0508 7.96498 36.2502 9.57793 39.545 12.2725C42.7969 14.9292 45.1683 18.6365 46.1502 22.8821H36.1247C34.4858 19.7027 31.1927 17.5326 27.3957 17.5326C21.9651 17.5326 17.5611 21.9759 17.5611 27.4596C17.5611 28.5773 17.7433 29.6503 18.0804 30.6528C18.1079 30.7319 18.1354 30.811 18.1646 30.8884C15.4252 28.8903 13.6764 25.857 13.6764 22.4608C13.6764 20.6519 14.1716 18.9478 15.0486 17.4466C15.2705 17.0649 15.5181 16.6969 15.7881 16.3444L13.3582 14.2173C16.8612 10.3741 21.8894 7.96498 27.4765 7.96498ZM27.4765 46.6292C17.1965 46.6292 8.80804 38.4751 8.32482 28.2351C11.1519 34.496 16.9626 38.788 23.6675 38.788C29.0569 38.788 33.865 36.0161 37.0137 31.6794H46.1588C44.1898 40.2445 36.5718 46.6292 27.4765 46.6292Z",
    fill: "#4E008E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashiaLogo);
export default __webpack_public_path__ + "static/media/cashia_logo.d70bebd76a3f7e1076188e510570e049.svg";
export { ForwardRef as ReactComponent };